<template>
  <el-select
    :value="value"
    :placeholder="placeholder"
    :style="selectStyle"
    :popper-class="popperClass"
    :class="selectClass"
    filterable
    remote
    clearable
    :multiple="multiple"
    :collapse-tags="collapseTags"
    :remote-method="handleSearch"
    :loading="loading"
    @input="handleInput"
    @visible-change="handleVisibleChange"
  >
    <el-option
      v-for="org in options"
      :key="org.orgId"
      :label="formatOrgOptionLabel(org)"
      :value="org.orgId"
      :disabled="isOrgOptionDisabled(org)"
    >
      <span class="org-option-text" :title="formatOrgOptionLabel(org)">{{ formatOrgOptionLabel(org) }}</span>
    </el-option>
    <div class="org-select-pager" @mousedown.prevent @click.stop>
      <el-button
        size="mini"
        :disabled="page <= 1 || loading"
        @click.stop="changePage(page - 1)"
      >上一页</el-button>
      <span class="org-select-pager__text">第 {{ page }} / {{ totalPages }} 页（每页{{ pageSize }}条）</span>
      <el-button
        size="mini"
        :disabled="page >= totalPages || loading"
        @click.stop="changePage(page + 1)"
      >下一页</el-button>
    </div>
  </el-select>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'UtwlOrgSelect',
  props: {
    value: {
      type: [String, Number, Array],
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入机构名称搜索'
    },
    width: {
      type: [String, Number],
      default: 200
    },
    pageSize: {
      type: Number,
      default: 10
    },
    popperClass: {
      type: String,
      default: 'org-select-popper'
    },
    errorMessage: {
      type: String,
      default: '加载机构失败'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    collapseTags: {
      type: Boolean,
      default: false
    },
    searchParam: {
      type: String,
      default: 'keyword'
    },
    selectClass: {
      type: [String, Object, Array],
      default: ''
    }
  },
  data() {
    return {
      options: [],
      loading: false,
      keyword: '',
      page: 1,
      total: 0
    };
  },
  computed: {
    selectStyle() {
      const width = typeof this.width === 'number' ? `${this.width}px` : this.width;
      return width ? { width } : null;
    },
    totalPages() {
      const total = Number(this.total || 0);
      const size = Number(this.pageSize || 10);
      return Math.max(1, Math.ceil(total / size));
    }
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value);
      this.$emit('change', value);
    },
    formatOrgOptionLabel(org) {
      if (!org) return '';
      const name = org.orgName != null ? String(org.orgName).trim() : '';
      const st = (org.statusName != null && String(org.statusName).trim())
        ? String(org.statusName).trim()
        : (org.statusCode != null && String(org.statusCode).trim() ? String(org.statusCode).trim() : '');
      if (!name && !st) return '';
      if (!st) return name;
      if (!name) return `（${st}）`;
      return `${name}（${st}）`;
    },
    isOrgOptionDisabled(org) {
      return !!(org && org.statusCode === 'PAUSED');
    },
    async loadOptions(page = 1, keyword = this.keyword) {
      this.loading = true;
      try {
        const nextPage = Math.max(1, Number(page || 1));
        const nextKeyword = String(keyword || '').trim();
        const keywordPayload = nextKeyword ? { [this.searchParam || 'keyword']: nextKeyword } : {};
        const res = await api.post('/org/list', {
          page: nextPage,
          pageSize: this.pageSize,
          ...keywordPayload
        });
        if (res.data.success) {
          const data = res.data.data || {};
          this.page = Number(data.page || nextPage) || nextPage;
          this.total = Number(data.total || 0) || 0;
          this.keyword = nextKeyword;
          this.options = Array.isArray(data.list) ? data.list : [];
        }
      } catch (e) {
        console.error(this.errorMessage, e);
      } finally {
        this.loading = false;
      }
    },
    handleSearch(query) {
      this.keyword = String(query || '').trim();
      this.loadOptions(1, this.keyword);
    },
    changePage(page) {
      const nextPage = Math.max(1, Number(page || 1));
      if (nextPage === this.page) return;
      this.loadOptions(nextPage, this.keyword);
    },
    handleVisibleChange(visible) {
      if (!visible) return;
      if (!Array.isArray(this.options) || this.options.length === 0) {
        this.loadOptions(1, this.keyword);
      }
    }
  }
};
</script>

<style>
.org-select-popper {
  width: 350px !important;
  max-width: 350px !important;
}

.org-select-popper .el-select-dropdown__list {
  max-width: 100%;
}

.org-select-popper .el-select-dropdown__item {
  display: flex;
  align-items: center;
  max-width: 100%;
}

.org-select-popper .org-option-text {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.org-select-popper .org-select-pager {
  position: sticky;
  bottom: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  border-top: 1px solid #ebeef5;
  background: #fff;
}

.org-select-popper .org-select-pager__text {
  color: #606266;
  font-size: 12px;
  white-space: nowrap;
}
</style>
